import React from 'react';
import { connect } from 'react-redux';

// Actions
import { setAdvancedOptions, setEditAdvancedOptions } from '../../../actions/stepsChat';

const AlignIconComponent = (props) => {

    // Actions
    const { advancedOptions, setEditAdvancedOptions } = props;

    // States
    const { alignButton } = props;

    const handleSelectOption = (option) => {
        setEditAdvancedOptions({
            editAdvancedOptions: true
        });
        advancedOptions({
            alignButton: option
        });
    }

    const itemClass = (active) =>
        `flex cursor-pointer items-center justify-center rounded-sm px-3 py-2.5 text-center text-sm transition-all duration-150 ${
            active
                ? 'bg-card font-semibold text-primary shadow-card'
                : 'font-medium text-muted-foreground hover:text-foreground'
        }`;

    return (
        <div className="grid grid-cols-2 gap-1 rounded-[12px] border border-border bg-secondary p-1">
            <div
                className={itemClass(alignButton === 'left')}
                onClick={() => handleSelectOption('left')}
            >
                Alineado a la izquierda
            </div>
            <div
                className={itemClass(alignButton === 'right')}
                onClick={() => handleSelectOption('right')}
            >
                Alineado a la derecha
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        alignButton: state.stepsChat.advancedOptions.alignButton,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setEditAdvancedOptions: (value) => dispatch(setEditAdvancedOptions(value)),
        advancedOptions: (value) => dispatch(setAdvancedOptions(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AlignIconComponent);